module.exports = __webpack_public_path__ + "img/3x.8c9087e.jpg";